module.exports = __webpack_public_path__ + "img/play.22d669f1.svg";